import axios from "axios";

const Api = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL,
  headers: {
    "content-type": "application/json",
    accept: "application/json"
  }
});

export default {
  countries: body => Api.get("/api/travelstart/flights/countries", body),
  search: body => Api.post("/api/travelstart/flights/search", body),
  priceCheck: body => Api.post("/api/travelstart/flights/priceCheck", body),
  paymentMethods: body =>
    Api.post("api/travelstart/flights/paymentMethods", body),
  book: body => Api.post("/api/travelstart/flights/book", body),
  packageList: body => Api.post("/api/flights/packages/list", body),
  checkRedirectStatus: id => Api.get(`/api/travelstart/flights/redirectCheck/${id}`),
  authorizeBooking: body => Api.post("api/travelstart/flights/authorizeBooking", body)
};
